import * as action_types from '../actions/action_types';

const initialState = {
  key: '',
  id: '',
};

export const FaultAppReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case action_types.SYNC_FAULT_MAP_WITH_TABLE:
      return {
        ...state,
        key: action.data.key,
        id: action.data.id,
      };
    default:
      return state;
  }
};
